/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ rating: NonNullable<unknown>, success: NonNullable<unknown> }} Ticket_Review_SummaryInputs */

const en_ticket_review_summary = /** @type {(inputs: Ticket_Review_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rating: ${i?.rating}/5 · Successful: ${i?.success}`)
};

const ja_ticket_review_summary = /** @type {(inputs: Ticket_Review_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`評価: ${i?.rating}/5 · 成功: ${i?.success}`)
};

const fr_ticket_review_summary = /** @type {(inputs: Ticket_Review_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Note : ${i?.rating}/5 · Réussi : ${i?.success}`)
};

const de_ticket_review_summary = /** @type {(inputs: Ticket_Review_SummaryInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bewertung: ${i?.rating}/5 · Erfolgreich: ${i?.success}`)
};

/**
* | output |
* | --- |
* | "Rating: {rating}/5 · Successful: {success}" |
*
* @param {Ticket_Review_SummaryInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_review_summary = /** @type {((inputs: Ticket_Review_SummaryInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Review_SummaryInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_review_summary(inputs)
	if (locale === "ja") return ja_ticket_review_summary(inputs)
	if (locale === "fr") return fr_ticket_review_summary(inputs)
	return de_ticket_review_summary(inputs)
});